import initI18n from './i18n';
import { seedUviloAnalysisSchemas } from './shared/seedUviloAnalysisSchemas';

export default function init() {
  initI18n();
  seedUviloAnalysisSchemas();
}
